import React from 'react';

interface GoalsBannerProps {
  teacherName?: string;
  evaluatedOn?: string;
}

const GoalsBanner: React.FC<GoalsBannerProps> = ({ teacherName, evaluatedOn }) => {
  return (
    <div className="w-full flex items-center justify-center bg-[#F6EFFF] border-b border-[#EBE0FA] h-[77px]">
      <div className="flex flex-row items-center gap-[35px]">
        {/* Evaluator */}
        <div className="flex flex-col items-center w-[200px] gap-[5px]">
          <p className="w-full text-center text-[12.5px] font-medium leading-[15px] text-[#A390BE] m-0">
            Evaluator
          </p>
          <p className="text-center text-[13px] font-bold text-[#7D4AC3] m-0">
            {teacherName || '—'}
          </p>
        </div>

        {/* Evaluated on */}
        <div className="flex flex-col items-center w-[200px] gap-[5px]">
          <p className="w-full text-center text-[12.5px] font-medium leading-[15px] text-[#A390BE] m-0">
            Evaluated on
          </p>
          <p className="w-full text-center text-[14px] font-bold text-[#7D4AC3] m-0">
            {evaluatedOn || '—'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default GoalsBanner;
